define(
    'views/secured/app.html',[
        "helper/appLayoutHelper"
    ],
    function (helper) {

        function compositionComplete(html, parentHtml, context) {
            return helper.compositionComplete(html, parentHtml, context);
        }

        return {
            compositionComplete: compositionComplete
        };
    });
